type Tone = 'slate' | 'green' | 'amber' | 'red' | 'blue' | 'purple';

const toneClasses: Record<Tone, string> = {
  slate: 'bg-slate-100 text-slate-700',
  green: 'bg-emerald-100 text-emerald-700',
  amber: 'bg-amber-100 text-amber-800',
  red: 'bg-red-100 text-red-700',
  blue: 'bg-blue-100 text-blue-700',
  purple: 'bg-purple-100 text-purple-700',
};

export function Badge({ tone = 'slate', children }: { tone?: Tone; children: React.ReactNode }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${toneClasses[tone]}`}>
      {children}
    </span>
  );
}

const ORG_STATUS_TONE: Record<string, Tone> = { ACTIVE: 'green', INACTIVE: 'slate' };
const USER_STATUS_TONE: Record<string, Tone> = { ACTIVE: 'green', INACTIVE: 'slate', LOCKED: 'red' };
const ORDER_STATUS_TONE: Record<string, Tone> = {
  PENDING_APPROVAL: 'amber',
  APPROVED: 'blue',
  AUTO_APPROVED: 'blue',
  REJECTED: 'red',
  ORDERED: 'purple',
  DELIVERED: 'green',
  INVOICED: 'slate',
  CANCELLED: 'red',
};
const ASSET_STATUS_TONE: Record<string, Tone> = {
  IN_SERVICE: 'green',
  SPARE: 'blue',
  FAULTY: 'amber',
  RETURNED: 'slate',
  DECOMMISSIONED: 'red',
  LOANED: 'purple',
};
const LOAN_STATUS_TONE: Record<string, Tone> = {
  PENDING_APPROVAL: 'amber',
  APPROVED: 'blue',
  REJECTED: 'red',
  CANCELLED: 'slate',
  ACTIVE: 'purple',
  RETURNED: 'green',
};

const STATUS_TONE_MAPS: Record<'org' | 'user' | 'order' | 'asset' | 'loan', Record<string, Tone>> = {
  org: ORG_STATUS_TONE,
  user: USER_STATUS_TONE,
  order: ORDER_STATUS_TONE,
  asset: ASSET_STATUS_TONE,
  loan: LOAN_STATUS_TONE,
};

export function StatusBadge({ status, kind }: { status: string; kind: 'org' | 'user' | 'order' | 'asset' | 'loan' }) {
  const map = STATUS_TONE_MAPS[kind];
  return <Badge tone={map[status] ?? 'slate'}>{status.replace(/_/g, ' ')}</Badge>;
}
